import ApiService from './ApiService'
export const AccountService = {

  baseURL: process.env.VUE_APP_CLINICAL_URL,

  get (slug, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/admin/accounts`, slug, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (params) {
    return ApiService.post(`${this.baseURL}/admin/accounts`, params)
  },

  update (resource, params) {
    return ApiService.put(`${this.baseURL}/admin/accounts/${resource}`, params)
  },

  destroy (resource) {
    return ApiService.delete(`${this.baseURL}/admin/accounts/${resource}`)
  },

  getHearingTrainingLevels (resource) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${this.baseURL}/admin/accounts/${resource}/hearing-training`)
        .then(response => {
          resolve(response.data.data)
        })
        .catch(errors => {
          console.log(errors)
          resolve([])
        })
    })
  },

  getByEmail(email) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${process.env.VUE_APP_AUTH_CLINICAL_URL}/admin/users?query=${email}`)
        .then(res => resolve(res.data.data))
        .catch(errors => reject(errors))
    })

    //https://api.dev.evollu.com/auth-clinical-evollu/admin/users?query=test123@evollu.com&limit=10&ascending=1&page=1&byColumn=0
  }
}

export const AccountPermissionsService = {

  baseURL: process.env.VUE_APP_CLINICAL_URL,

  get () {
    return new Promise((resolve, reject) => {
      ApiService.query(`${this.baseURL}/admin/accounts-permissions`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },
  store (entityId, data) {
    return ApiService.post(`${this.baseURL}/admin/entities/${entityId}/account-permissions`, data)
  }
}

export const InvitationService = {

  baseURL: process.env.VUE_APP_CLINICAL_URL,

  store (params) {
    return ApiService.post(`${this.baseURL}/admin/invitations`, params)
  }
}
